import * as React from 'react';
import { Button, Modal, Table } from 'antd';
import { TableProps } from 'antd/lib/table';
import './HistoryModal.less';

export interface HistoryModalProps<Row extends object> {
    title: string;
    visible: boolean;
    onClose: () => void;
    afterClose?: () => void;
    rows: readonly Row[];
    columns: TableProps<Row>['columns'];
    rowKey: NonNullable<TableProps<Row>['rowKey']>;
    rowClassName?: TableProps<Row>['rowClassName'];
    emptyText?: React.ReactNode;
    notice?: React.ReactNode;
    expandable?: TableProps<Row>['expandable'];
    pagination?: TableProps<Row>['pagination'];
    onChange?: TableProps<Row>['onChange'];
    className?: string;
    tableClassName?: string;
    loading?: boolean;
    scrollX?: number | string;
}

export default function HistoryModal<Row extends object>({
    title,
    visible,
    onClose,
    afterClose,
    rows,
    columns,
    rowKey,
    rowClassName,
    emptyText,
    notice,
    expandable,
    pagination = { pageSize: 20, hideOnSinglePage: true, showSizeChanger: false },
    onChange,
    className,
    tableClassName,
    loading,
    scrollX
}: HistoryModalProps<Row>): JSX.Element {
    return (
        <Modal
            className={['history-modal', className].filter(Boolean).join(' ')}
            title={title}
            visible={visible}
            maskClosable={false}
            width={1400}
            destroyOnClose
            forceRender
            centered
            onCancel={onClose}
            afterClose={afterClose}
            footer={[
                <Button key="close-button" className="light alpha-dialog-button" onClick={onClose}>
                    Close
                </Button>
            ]}
        >
            {notice}
            <Table<Row>
                loading={loading}
                className={['history-table', tableClassName].filter(Boolean).join(' ')}
                dataSource={rows}
                columns={columns}
                rowKey={rowKey}
                rowClassName={rowClassName}
                locale={emptyText === undefined ? undefined : { emptyText }}
                expandable={expandable}
                pagination={pagination}
                onChange={onChange}
                scroll={{ x: scrollX, y: 800 }}
            />
        </Modal>
    );
}
